// extracted by mini-css-extract-plugin
module.exports = {"bundle":"bundle_bundle___dviy","trash":"bundle_trash__3d8Qx"};